<div class="text-center">

  <h1 mat-dialog-title translate> dialog.passwordchange.title </h1>
  <div class="modal-body" mat-dialog-content>

    <mat-form-field floatLabel="always" autocomplete="off">
      <mat-label translate>
        pages.landing.fields.oldpassword.label
      </mat-label>
      <input #oldPassword [type]="getPswTypeOld()" matInput>
      <mat-icon class="align-middle cursor" matSuffix (click)="switchVisibilityOld()">
        {{psw_visibility_old}}
      </mat-icon>
    </mat-form-field>

    <br>

    <mat-form-field floatLabel="always" autocomplete="off">
      <mat-label translate>
        pages.landing.fields.newpassword.label
      </mat-label>
      <input #newPassword [type]="getPswTypeNew()" matInput>
      <mat-icon class="align-middle cursor" matSuffix (click)="switchVisibilityNew()">
        {{psw_visibility_new}}
      </mat-icon>
    </mat-form-field>

    <br>

    <mat-form-field floatLabel="always" autocomplete="off">
      <mat-label translate>
        pages.landing.fields.repeatpassword.label
      </mat-label>
      <input #repeatPassword [type]="getPswTypeRepeat()" matInput>
      <mat-icon class="align-middle cursor" matSuffix (click)="switchVisibilityRepeat()">
        {{psw_visibility_repeat}}
      </mat-icon>
    </mat-form-field>
  </div>

</div>
<div class="modal-footer" mat-dialog-actions translate>

  <ng-container *ngIf="forced == 0">
    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
    dialog.passwordchange.cancell
    </button>
  </ng-container>

 <ng-container>
    <button type="button" class="btn btn-outline-secondary"
    (click)="continue(oldPassword.value, newPassword.value, repeatPassword.value)" translate>
    dialog.passwordchange.confirm
  </button>
 </ng-container>

</div>